import styled from "styled-components";

export const ProjectWrapper = styled.section`
  padding: 40px 0; /* tinanggal side padding */
  background: #141414;
  color: white;
  width: 100%;

  h5 {
    text-align: center;
    margin-bottom: 10px;
    color: #0ff;
  }
`;

export const ProjectContainer = styled.div`
  display: flex;
  gap: 25px;

  overflow-x: auto;
  overflow-y: hidden;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* smooth iOS */
  scroll-snap-type: x mandatory; /* snap scroll */

  padding: 20px 20px 30px 20px; /* mas malaki vertical space */
  box-sizing: border-box;

  justify-content: flex-start;

  /* mas malaking scroll area sa mobile */
  @media (max-width: 768px) {
    padding: 30px 20px 40px 20px;
  }

  &::-webkit-scrollbar {
    height: 30px; /* mas makapal */
  }

  &::-webkit-scrollbar-thumb {
    background: cyan;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: #141414;
  }
`;

export const ProjectCard = styled.div`
  flex: 0 0 450px;   /* IMPORTANT: prevents shrink */
  height: 300px;

  background: rgba(255,255,255,0.05);
  border-radius: 18px;
  padding: 20px;
  text-align: center;
  transition: 0.3s;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 0 20px cyan;
  }

  h5 {
    font-size: 1rem;
    margin-top: 10px;
  }

  .slider-image-container {
    flex: none;
    height: 230px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
    display: block;
  }

  /* ARROWS */
  .slick-prev,
  .slick-next {
    z-index: 2;
    width: 40px;
    height: 40px;
    top: 50%;
    transform: translateY(-50%);
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 35px;
    color: #0ff;
    opacity: 1;
  }

  .slick-prev { left: -25px; }
  .slick-next { right: -25px; }

  @media (max-width: 500px) {
  flex: 0 0 90vw;   /* mas malapad */
  height: 250px;    /* mas mababa kaysa width */

  padding: 15px;

  .slider-image-container {
    height: 180px;
  }

  h5 {
    font-size: 0.95rem;
    margin-top: 8px;
  }

  .slick-prev,
  .slick-next {
    width: 28px;
    height: 28px;
  }

  .slick-prev:before,
  .slick-next:before {
    font-size: 24px;
  }

  .slick-prev { left: -15px; }
  .slick-next { right: -15px; }
}
`;